let api = {
  // feedback:'/platform/feedback/grid-feed-back.htm',//意见反馈列表
  // fdDetail:'/platform/feedback/find-feed-back.htm',//意见反馈详情
  // contactUs:'/platform/content/find-content.htm',//联系我们
  // contactUsEdit:'/platform/content/insert-content.htm',//编辑联系我们
  // hotWord:'/platform/hotkey/grid-hot-key.htm',//搜索热词
  // hotWordEdit:'/platform/hotkey/update-hot-key.htm',//修改搜索热词
  // hotWordAdd:'/platform/hotkey/insert-hot-key.htm',//新增搜索热词
  // hotWordDelete:'/platform/hotkey/delete-hot-key.htm',//删除搜索热词

  // orderList:'/platform/newspaper/grid-norder.htm',//订单列表
  // orderDetail:'/platform/newspaper/find-norder.htm',//订单详情
  // reportList:'/platform/newspaper/grid-ntype.htm',//报纸刊登列表
  // reportDetail:'/platform/newspaper/find-ntype.htm',//报纸刊登列表
  // reportUpdata:'/platform/newspaper/insert-or-update-ntype.htm',//报纸刊登列表

  // hallDetail:'/platform/pwork/find-pwork.htm',//业务详情
  // hallList:'/platform/pwork/grid-pwork.htm',//业务列表
  // hallUpdata:'/platform/pwork/insert-or-update-pwork.htm',//新增编辑业务

  // //企业中心
  // centerDelete:'/platform/firm/delete-firm-type.htm',
  // centerList:'/platform/firm/grid-firm-type.htm',
  // centerUpdata:'/platform/firm/update-firm-type.htm',
  // centerAdd:'/platform/firm/insert-firm-type.htm',
  // businessList:'/platform/firm/grid-firm.htm',
  // businessUpdata:'/platform/firm/insert-or-update-firm.htm',
  // businessDetail:'/platform/firm/find-firm.htm',
  // //会展直播
  // radioTypeDelete:'/platform/live/delete-live-type.htm',
  // radioTypeList:'/platform/live/grid-live-type.htm',
  // radioTypeUpdata:'/platform/live/update-live-type.htm',
  // radioTypeAdd:'/platform/live/insert-live-type.htm',
  // radioList:'/platform/live/grid-live.htm',
  // radioUpdata:'/platform/live/insert-or-update-live.htm',
  // radioDetail:'/platform/live/find-live.htm',
  // //虚拟展厅
  // showTypeDelete:'/platform/virtual/delete-virtual-type.htm',
  // showTypeList:'/platform/virtual/grid-virtual-type.htm',
  // showTypeUpdata:'/platform/virtual/update-virtual-type.htm',
  // showTypeAdd:'/platform/virtual/insert-virtual-type.htm',
  // showList:'/platform/virtual/grid-virtual.htm',
  // showUpdata:'/platform/virtual/insert-or-update-virtual.htm',
  // showDetail:'/platform/virtual/find-virtual.htm',





  // roleDelete:`/platform/role/delete-role.htm`,//角色删除
  // roleDetail:`/platform/role/find-role.htm`,//角色详情
  // updataRole:`/platform/role/update-role-status.htm`,//更新角色状态
  // editRole:`/platform/role/update-role.htm`,//编辑角色
  // addRole:`/platform/role/insert-role.htm`,//新增角色

  // roleMenu:`/platform/role/menu-tree.htm`,//全部菜单

  // menuList:`/platform/user/grid-user-menu.htm`,//用户菜单
  // updataPassword:`/system/changePwd.htm`,//修改密码

  // noticeList:'/platform/information/grid-information.htm',//公告列表
  // noticeDelete:'/platform/information/delete-information.htm',
  // noticeDetail:'/platform/information/find-information.htm',
  // noticeAdd:'/platform/information/insert-information.htm',
  // noticeEdit:'/platform/information/update-information.htm',





  // me
  getCode: '/web/common/validateCode',//获取验证码
  login: '/web/sysUser/auth',//登录
  logout: '/web/sysUser/logout', //登出
  userList: `/web/user/getShopList`,//用户列表
  changeShopStatus: `/web/user/changeShopStatus`,//门店管理  解冻冻结账号
  setAgent: `/web/user/setAgent`, //代理商
  shopDetails: '/web/user/getShopById',//门店详情
  systemList: `/web/sysUser/list`,//系统用户列表
  addSystem: `/web/sysUser/add`,//新增系统用户
  updataSystem: `/web/sysUser/update`,//更新系统用户
  deleteSystem: `/web/sysUser/deleteById`,//删除系统用户
  updataStatus: `/web/sysUser/status`,
  systemDetail: `/web/sysUser/getSysUserById`,//系统用户详情
  banner: '/web/banner/list',//轮播图
  bannerAdd: '/web/banner/add',//新增轮播图
  bannerDelete: '/web/banner/delete',//删除轮播图
  bannerEdit: '/web/banner/update',//编辑轮播图
  getFileUrl: '/web/common/uploadFile',// 图片上传接口
  getOrderList: '/web/order/list',  //订单列表
  getOrderDetails: '/web/order/getOrderById', //根据id查询订单详情
  exportOrder: '/web/order/export', //导出订单
  exportCompensateAudit: '/web/compensate/export', //导出理赔审核
  exportGuarantee: '/web/guarantee/export', //导出三包售后审核
  compensateAudit: '/web/compensate/compensateAudit',//理赔申请审核
  getAuditDetails: '/web/compensate/getCompensateById',//根据id获取详情
  getAuditList: '/web/compensate/list',//获取compensate列表
  getGuaranteeList: '/web/guarantee/list',//获取三包理赔列表
  getGuaranteeDetails: '/web/guarantee/getGuaranteeById',//根据id查询详情
  guaranteeAudit: '/web/guarantee/guaranteeAudit',//审核售后三包
  guaranteeDeliver: '/web/guarantee/deliver',//发货
}
export default api


// WEBPACK FOOTER //
// ./src/api/api.js